import { createAsyncThunk } from "@reduxjs/toolkit";
import {
	HojaObraGruesa,
	HojaTerminaciones,
	SheetOuterJoinOT,
	SheetOT,
} from "src/models/OT/Sheet";
import { getRef } from "src/utils/firebase";
import Firebase from "firebase";
import { RootState } from "src/redux/store/reducer";
import { createInitialReviewerResponse } from "../utils/sheet";
import { otActions } from "../slice";
import { openSnack } from "src/redux/actions/uiActions";
import { SnackState } from "src/models/snack-state";
import { firestore } from "src/firebase/firebase";
import { FirebaseListener } from "src/utils/classes/FirebaseListeners";
import { Usuario } from "src/models/Usuario";
import { setUsers } from "src/redux/actions/usersActions";
import { AssignedPlaceOT } from "src/models/OT/Place";
import { updatePendingStatusAfterChange } from "src/utils/pendingItemsCalculator";

const listener = FirebaseListener.addListener("sheets-ot");

export const getPlaceSheetsOT = createAsyncThunk<SheetOT[]>(
	"checklists-ot/checklists/places/sheets/get",
	async (_, { dispatch, getState }) => {
		const place = (getState() as RootState)
			.neoChecklistReducer.selected.assignedPlace!;
			console.log("place",place)
		const sheetsRef =
			getRef(place).collection("RespuestasOT");

		const query = sheetsRef.orderBy(
			"FechaCreacion",
			"desc"
		);

		listener.close();

		return new Promise<SheetOT[]>((resolve, reject) => {
			query.get().then(
				(snap) => {
					const sheets = snap.docs.map((d, i, arr) => {
						const sheet = {
							...d.data(),
							_ref: d.ref,
							_position: arr.length - i,
						} as SheetOT;

						const selectedId = (getState() as RootState)
							.neoChecklistReducer.selected.sheet?._ref?.id;

						if (selectedId === d.id)
							dispatch(
								otActions.assignSelected({ sheet: sheet })
							);

						return sheet;
					});

					console.log("respondio", sheets);
					dispatch(
						otActions.assignChecklist({ responses: sheets })
					);
					resolve(sheets);
				},
				(error) => {
					console.error(error);
					dispatch(
						openSnack(
							error.message,
							SnackState.ERROR
						) as any
					);
					reject(error);
				}
			);
		});
	}
);

type SheetCreator = {
	type: SheetOT["Tipo"];
	initialValues: SheetOuterJoinOT & {
		Unidades: number;
	};
};

export const addSheetToProjectSpaceOT = createAsyncThunk(
	"checklists-ot/checklists/places/sheets/add",
	async (
		{ type, initialValues }: SheetCreator,
		{ getState, dispatch }
	) => {
		try {
			const place = (getState() as RootState)
				.neoChecklistReducer.selected.assignedPlace!;
			const checklist = (getState() as RootState)
				.neoChecklistReducer.selected.checklist!;
			const placeRef = getRef(place);

			console.log(`[addSheetToProjectSpaceOT] 🏠 Place seleccionado:`, {
				nombre: place.Nombre,
				asignado: place.Asignado,
				id: place._ref?.id,
				path: place._ref?.path,
				placeRefPath: placeRef.path
			});
			const sheetRef = placeRef
				.collection("RespuestasOT")
				.doc();

			const reviewerSnaps = await Promise.all(
				place.Revisores.filter((r) => r !== null).map((r) =>
					r!.get()
				)
			);

			const reviewers = reviewerSnaps.map((snap) => {
				if (!snap.exists) {
					throw Error(
						"Uno de los revisores asignados fue eliminado. Por favor, cámbialo."
					);
				}

				return {
					...snap.data(),
					_ref: snap.ref,
				} as Usuario;
			});

			const sheetData: Omit<
				HojaObraGruesa | HojaTerminaciones,
				"FechaCreacion"
			> = {
				PreguntasMalas: 0,
				Estado: "En Proceso",
				Tipo: type,
				Unidades: initialValues.Unidades,
				Revisores: reviewers.map((r) =>
					createInitialReviewerResponse(
						r,
						checklist.Preguntas
					)
				),
				EspacioRef: placeRef,
				NombreEspacio: place.Nombre,
				ChecklistRef: placeRef.parent.parent!,
				NombreChecklist: checklist.Nombre,
				ProyectoRef: placeRef.parent.parent!.parent.parent!,
			};

			if (type === "Obra Gruesa") {
				const { PlanoRevisor, Elemento, Ubicacion } =
					initialValues as HojaObraGruesa;
				(sheetData as HojaObraGruesa).PlanoRevisor =
					PlanoRevisor;
				(sheetData as HojaObraGruesa).Elemento = Elemento;
				(sheetData as HojaObraGruesa).Ubicacion = Ubicacion;
			} else if (type === "Terminaciones") {
				const { Sector, Recinto, Pasillo, Otro } =
					initialValues as HojaTerminaciones;
				(sheetData as HojaTerminaciones).Recinto = Recinto;
				(sheetData as HojaTerminaciones).Sector = Sector;
				(sheetData as HojaTerminaciones).Pasillo = Pasillo;
				(sheetData as HojaTerminaciones).Otro = Otro;
			} else
				throw Error("El tipo de la respuesta es inválido.");

			const batch = firestore.batch();

			batch.set(sheetRef, {
				...sheetData,
				FechaCreacion: Firebase.firestore.Timestamp.now(),
			});

			batch.update(placeRef, { Contado_: false });

			await batch.commit();

			// Recalcular campos de items pendientes después de crear la hoja
			try {
				// Derivar IDs reales desde la ruta del placeRef para evitar desajustes con el estado de UI
				const pathParts = placeRef.path.split('/');
				const empresaIdFromPath = pathParts[1]; // empresas/{empresaId}
				// Estructura de placeRef: .../ChecklistsOT/{checklistId}/EspaciosAsignadosOT/{espacioId}
				const espacioId = placeRef.id;                            // EspacioAsignadoOT document ID
				const checklistId = placeRef.parent.parent!.id;          // ChecklistsOT document ID
				const projectId = placeRef.parent.parent!.parent.parent!.id;  // ProyectosOT document ID

				console.log(`[addSheetToProjectSpaceOT] Rutas extraídas - empresa: ${empresaIdFromPath}, proyecto: ${projectId}, checklist: ${checklistId}, espacio: ${espacioId}`);
				console.log(`[addSheetToProjectSpaceOT] Ruta completa del placeRef: ${placeRef.path}`);

				// Log de verificación de estructura
				console.log(`[addSheetToProjectSpaceOT] 🔍 Verificación de estructura:`);
				console.log(`[addSheetToProjectSpaceOT] placeRef.parent.parent.path: ${placeRef.parent.parent!.path}`);

				// Verificar que el placeRef existe antes de intentar recalcular
				const placeDoc = await placeRef.get();
				if (!placeDoc.exists) {
					console.warn(`[addSheetToProjectSpaceOT] ❌ El placeRef no existe: ${placeRef.path}`);
					console.warn(`[addSheetToProjectSpaceOT] ⚠️ Saltando recálculo`);
					return;
				}

				const placeData = placeDoc.data();
				console.log(`[addSheetToProjectSpaceOT] ✅ PlaceRef existe - datos:`, {
					asignado: placeData?.Asignado,
					nombre: placeData?.Nombre,
					hasPendingItems: placeData?.hasPendingItems,
					pendingResponsesCount: placeData?.pendingResponsesCount
				});

				await updatePendingStatusAfterChange(
					empresaIdFromPath,
					projectId,
					checklistId,
					espacioId
				);
				console.log('[addSheetToProjectSpaceOT] Campos de items pendientes recalculados exitosamente');
			} catch (recalcError: any) {
				// No fallar la operación principal si falla el recálculo
				console.warn('[addSheetToProjectSpaceOT] Error recalculando items pendientes, pero la hoja se creó exitosamente:', recalcError.message);
			}

			dispatch(
				openSnack(
					"Hemos agregado la hoja de respuestas.",
					SnackState.SUCCESS
				) as any
			);
		} catch (error: any) {
			console.error(error);
			dispatch(
				openSnack(error.message, SnackState.ERROR) as any
			);
		}
	}
);

export const removeSheetFromProjectSpaceOT =
	createAsyncThunk(
		"checklists-ot/checklists/places/sheets/remove",
		async (sheet: SheetOT, { dispatch, getState }) => {
			try {
				const images: string[] = [];
				const sheetRef = getRef(sheet);
				const placeRef = sheetRef.parent.parent!;

				const { Revisores } = sheet;

				Revisores.forEach((revisor) => {
					const { Firma, Categorias } = revisor;

					Firma && images.push(Firma.Uri);

					Categorias.flatMap(
						(category) => category.Preguntas
					)
						.flatMap((question) => question.Respuestas)
						.flatMap((response) => response?.Foto)
						.forEach(
							(photo) => photo && images.push(photo.Uri)
						);
				});

				const batch = firestore.batch();

				batch.set(
					firestore.collection("ImagesToDelete").doc(),
					{ images }
				);

				batch.delete(sheetRef);

				batch.update(placeRef, {
					Contado_: false,
				});

				await batch.commit();

				// Recalcular campos de items pendientes después de eliminar la hoja
				try {
					// Derivar IDs reales desde la ruta del placeRef para evitar desajustes con el estado de UI
					const pathParts = placeRef.path.split('/');
					const empresaIdFromPath = pathParts[1]; // empresas/{empresaId}

					// placeRef apunta a: /empresas/{empresaId}/ProyectosOT/{projectId}/ChecklistsOT/{checklistId}/EspaciosAsignadosOT/{espacioId}
					const espacioId = placeRef.id;
					const checklistId = placeRef.parent.parent!.id;
					const projectId = placeRef.parent.parent!.parent.parent!.id;

					console.log(`[removeSheetFromProjectSpaceOT] Rutas extraídas - empresa: ${empresaIdFromPath}, proyecto: ${projectId}, checklist: ${checklistId}, espacio: ${espacioId}`);

					await updatePendingStatusAfterChange(
						empresaIdFromPath,
						projectId,
						checklistId,
						espacioId
					);
					console.log('[removeSheetFromProjectSpaceOT] Campos de items pendientes recalculados exitosamente');
				} catch (recalcError: any) {
					// No fallar la operación principal si falla el recálculo
					console.warn('[removeSheetFromProjectSpaceOT] Error recalculando items pendientes, pero la hoja se eliminó exitosamente:', recalcError.message);
				}

				// Actualizar la lista de hojas después de eliminar
				await dispatch(getPlaceSheetsOT());

				dispatch(
					openSnack(
						"Hemos eliminado la hoja de respuestas.",
						SnackState.SUCCESS
					) as any
				);
			} catch (error: any) {
				console.error(error);
				dispatch(
					openSnack(
						error.message,
						SnackState.ERROR
					) as any
				);
				throw error;
			}
		}
	);

export const getChecklistPlacesWithYellowResponses = createAsyncThunk<{
	yellowResponses: Record<string, boolean>,
	blueYellowResponses: Record<string, boolean>,
	inProcessResponses: Record<string, boolean>
}>(
	"checklists-ot/checklists/places/yellow-responses/get",
	async (_, { dispatch, getState }) => {
		try {
			const checklist = (getState() as RootState)
				.neoChecklistReducer.selected.checklist!;

			const checklistPlaces = (getState() as RootState)
				.neoChecklistReducer.checklist.places;

			if (!checklistPlaces || checklistPlaces.length === 0) {
				return { yellowResponses: {}, blueYellowResponses: {}, inProcessResponses: {} };
			}

			// Import the utility functions
			const { hasBlueYellowResponses } = await import("src/models/OT/utils/sheets");

			// Create a batch of promises to query all places in parallel
			const placeQueries = checklistPlaces.map(async (place) => {
				const placeRef = getRef(place);
				const placeId = placeRef.id;

				// First check if there are any responses at all
				const sheetsRef = placeRef.collection("RespuestasOT");
				const anyResponsesQuery = sheetsRef.limit(1);
				const anyResponsesSnapshot = await anyResponsesQuery.get();

				// If there are no responses at all, this place doesn't have any special responses
				if (anyResponsesSnapshot.empty) {
					return {
						placeId,
						hasYellowResponses: false,
						hasBlueYellowResponses: false
					};
				}

				// Query for sheets without FechaRevisionFinal (yellow responses)
				const yellowSheetsQuery = sheetsRef.where("FechaRevisionFinal", "==", null).limit(1);
				const yellowSnapshot = await yellowSheetsQuery.get();
				const hasYellow = !yellowSnapshot.empty;

				// For blue-yellow responses, we need to fetch all sheets and check their content
				let hasBlueYellow = false;
				// Always check for blue-yellow responses, regardless of yellow responses
				const allSheetsQuery = sheetsRef.get();
				const allSheetsSnapshot = await allSheetsQuery;

				if (!allSheetsSnapshot.empty) {
					const sheets = allSheetsSnapshot.docs.map(doc => ({
						...doc.data(),
						_ref: doc.ref
					} as SheetOT));

					// Check if any sheet has X/P combinations or unanswered questions
					hasBlueYellow = hasBlueYellowResponses(sheets);
				}

				// Use pre-calculated hasPendingItems field instead of querying individual responses
				// This field is updated by the system when responses change state (see README_LOGICA_ICONOS_CHECKLIST.md)
				const placeDoc = await placeRef.get();
				const placeData = placeDoc.data() as AssignedPlaceOT;
				const hasInProcess = placeData?.hasPendingItems || false;

				console.log(`[P Calculation] Place ${placeId} - hasPendingItems:`, placeData?.hasPendingItems, '(type:', typeof placeData?.hasPendingItems, ') -> hasInProcess:', hasInProcess);

				// If hasPendingItems is undefined, it means the field hasn't been calculated yet
				if (placeData?.hasPendingItems === undefined) {
					console.warn(`[P Calculation] Place ${placeId} - hasPendingItems field is undefined. Field needs to be populated by system.`);
				}

				return {
					placeId,
					hasYellowResponses: hasYellow,
					hasBlueYellowResponses: hasBlueYellow,
					hasInProcessResponses: hasInProcess
				};
			});

			// Wait for all queries to complete
			const results = await Promise.all(placeQueries);

			// Convert results to record objects
			const placesWithYellowResponses = {} as Record<string, boolean>;
			const placesWithBlueYellowResponses = {} as Record<string, boolean>;
			const placesWithInProcessResponses = {} as Record<string, boolean>;

			results.forEach(({ placeId, hasYellowResponses, hasBlueYellowResponses, hasInProcessResponses }) => {
				if (hasYellowResponses) {
					placesWithYellowResponses[placeId] = true;
				}
				if (hasBlueYellowResponses) {
					placesWithBlueYellowResponses[placeId] = true;
				}
				if (hasInProcessResponses) {
					placesWithInProcessResponses[placeId] = true;
				}
			});

			// Store in localStorage for sharing with other components
			const checklistId = getRef(checklist).id;

			// Handle yellow responses
			const storedYellowData = localStorage.getItem('placesWithYellowResponses');
			const yellowResponsesData = storedYellowData ? JSON.parse(storedYellowData) : {};
			yellowResponsesData[checklistId] = {};
			Object.keys(placesWithYellowResponses).forEach(placeId => {
				yellowResponsesData[checklistId][placeId] = true;
			});
			localStorage.setItem('placesWithYellowResponses', JSON.stringify(yellowResponsesData));

			// Handle blue-yellow responses
			const storedBlueYellowData = localStorage.getItem('placesWithBlueYellowResponses');
			const blueYellowResponsesData = storedBlueYellowData ? JSON.parse(storedBlueYellowData) : {};
			blueYellowResponsesData[checklistId] = {};
			Object.keys(placesWithBlueYellowResponses).forEach(placeId => {
				blueYellowResponsesData[checklistId][placeId] = true;
			});
			localStorage.setItem('placesWithBlueYellowResponses', JSON.stringify(blueYellowResponsesData));

			// We don't store in-process responses in localStorage anymore
			// They are always fetched from the server

			return {
				yellowResponses: placesWithYellowResponses,
				blueYellowResponses: placesWithBlueYellowResponses,
				inProcessResponses: placesWithInProcessResponses
			};
		} catch (error: any) {
			console.error("Error checking for yellow responses:", error);
			dispatch(openSnack(error.message, SnackState.ERROR) as any);
			return { yellowResponses: {}, blueYellowResponses: {}, inProcessResponses: {} };
		}
	}
);

export const getSheetUsers = createAsyncThunk(
	"checklists-ot/checklists/places/sheets/users/get",
	async (_, { dispatch, getState }) => {
		try {
			const sheets = (getState() as RootState)
				.neoChecklistReducer.checklist.responses;

			if (!sheets) return;

			const unique: Record<
				string,
				Firebase.firestore.DocumentReference
			> = {};

			sheets.forEach((sheet) => {
				const { Revisores } = sheet;

				Revisores.forEach((revisor) => {
					const { Revisor } = revisor;
					unique[Revisor.id] = Revisor;
				});
			});

			console.log(Object.values(unique).length);

			const users = await Promise.all(
				Object.values(unique).map(async (ref) => {
					const snap = await ref.get();
					return {
						...snap.data(),
						_ref: ref,
						id: ref.id,
					} as Usuario;
				})
			);

			dispatch(setUsers(users));
		} catch (error: any) {
			console.error(error);
			dispatch(
				openSnack(error.message, SnackState.ERROR) as any
			);
		}
	}
);
